import { Box, Typography } from "@mui/material";
import ProfileCardMini from "../../../../common/ProfileCardMini/ProfileCardMini";
import LoadingWheel from "../../../../common/LoadingWheel/LoadingWheel";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import CompetitionDDL from "../CompetitionDDL/CompetitionDDL";
import moment from "moment";
import { white } from "../../../../../theme/colours";

const GrandPrizeArea = ({
  compData,
  currCompetition,
  setCurrCompetition,
  gpBanner,
  bannersLoading,
}) => {
  const { userState, mobileView, tabletView, userRankInfo, firebaseState } =
    useContext(GlobalContext);
  const notDesktop = mobileView || tabletView;
  const { t } = useTranslation("SafeRoads");

  const currentDate = moment();
  const week = useRef(currentDate.format("YYYY-WW"));

  const [avatarSource, setAvatarSource] = useState("");
  const [userTotal, setUserTotal] = useState(null);
  const [dataLoading, setDataLoading] = useState(true);

  const personalBoxStyle = {
    width: mobileView || tabletView ? "100%" : "30%",
    display: "flex",
    flexDirection: mobileView
      ? "column-reverse"
      : tabletView
      ? "row-reverse"
      : "column",
    justifyContent: notDesktop ? "space-between" : "space-around",
    padding: 0,
    borderRadius: "1rem",
    mb: mobileView ? "0.75rem" : tabletView && "1.5rem",
    height: mobileView && !compData ? "575.5px" : "fit-content",
    order: notDesktop && -1,
    alignItems: "center",
  };
  const imageStyle = { borderRadius: "16px", mt: "0.75rem", width: "100%" };
  const emptyBannerStyle = {
    borderRadius: "1rem",
    mt: "0.75rem",
    width: "100%",
    height: "26rem",
    background: "grey",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    p: "0.5rem 0",
  };

  useEffect(() => {
    if (userState.avatar) {
      const typeNumber = Math.max(parseInt(userState.avatar.substring(4)), 12);
      setAvatarSource(`images/avatars/type${typeNumber || "12"}.svg`);
    }
  }, [userState]);

  useEffect(() => {
    const getUserTotal = async () => {
      setDataLoading(true);
      const userScores = await firebaseState.getUserScoresInRange(
        week.current,
        week.current,
        userState.profileID,
      );
      userScores && setUserTotal(userScores.total);
      setDataLoading(false);
    };
    userState?.profileID && getUserTotal();
  }, [userState.profileID, firebaseState]);

  return (
    <Box sx={personalBoxStyle}>
      {!dataLoading && userState && userTotal !== null ? (
        <>
          <CompetitionDDL
            currCompetition={currCompetition}
            setCurrCompetition={setCurrCompetition}
            full
          />
          <ProfileCardMini
            userTotal={userTotal}
            avatarSource={avatarSource}
            orgRank={userRankInfo}
            src
          />
          {!notDesktop && currCompetition?.iteration?.id && (
            <>
              {gpBanner ? (
                <Box
                  component="img"
                  alt={t("userScore")}
                  src={gpBanner}
                  sx={imageStyle}
                />
              ) : (
                <Box sx={emptyBannerStyle}>
                  {bannersLoading ? (
                    <LoadingWheel width={4} />
                  ) : (
                    <Typography color={white} variant="h2">
                      {"Error Loading Banner"}
                    </Typography>
                  )}
                </Box>
              )}
            </>
          )}
        </>
      ) : (
        <LoadingWheel width={4} />
      )}
    </Box>
  );
};

export default GrandPrizeArea;
